<template>
    <div id="edit-delivery-date-page">
        <div class="top-buttons">
            <ui5-button @click="editDeliveryDate">
                {{ trans('pages.edit_deliverydate_page.save') }}
            </ui5-button>
            <ui5-button @click="$router.go(-1)">
                {{ trans('pages.edit_deliverydate_page.cancel') }}
            </ui5-button>
        </div>

        <div
            id="editdeliverydatefields"
            v-if="
                deliveryDate && routes && drivers && trucks && deliveryMethods
            "
        >
            <pre
                v-if="isDebug"
                class="debug-info"
                >{{ deliveryDate }}</pre
            >
            <div class="field">
                <ui5-label for="to-be-planned">
                    {{ trans('pages.edit_deliverydate_page.to_be_planned') }}
                </ui5-label>
                <ui5-select
                    id="to-be-planned"
                    @change="
                        deliveryDate.toBePlanned =
                            $event.detail.selectedOption.value;
                        deliveryDate.date = moment().format('YYYY-MM-DD');
                    "
                >
                    <ui5-option
                        value="0"
                        :selected="0 == deliveryDate.toBePlanned"
                    >
                        {{ trans('pages.edit_deliverydate_page.no') }}
                    </ui5-option>
                    <ui5-option
                        value="1"
                        :selected="1 == deliveryDate.toBePlanned"
                    >
                        {{ trans('pages.edit_deliverydate_page.yes') }}
                    </ui5-option>
                </ui5-select>
            </div>

            <!-- Recurring Trip section-->
            <div
                class="field"
                v-if="!isEditMode"
            >
                <ui5-checkbox
                    :checked="isRecurring"
                    @change="isRecurring = $event.target.checked"
                    id="recurring-checkbox"
                    :text="trans('pages.edit_deliverydate_page.recurring')"
                />
            </div>

            <!-- Recurring Trip Setting -->
            <recurring-trip-settings
                v-if="isRecurring && !isEditMode"
                :config="recurringConfig"
                @update:frequencyInterval="recurringConfig.frequencyInterval = $event"
                @update:daysOfWeek="recurringConfig.daysOfWeek = $event"
                @update:endType="recurringConfig.endType = $event"
                @update:endDate="recurringConfig.endDate = $event"
            />
            <div
                class="field"
                v-if="deliveryDate.toBePlanned == 0"
            >
                <ui5-label for="day">
                    {{ trans('pages.edit_deliverydate_page.date') }}
                    <small>
                        {{ trans('pages.edit_deliverydate_page.date_format') }}
                    </small>
                    :
                </ui5-label>
                <ui5-date-picker
                    id="day"
                    name="day"
                    format-pattern="yyyy-MM-dd"
                    @click="$event.target.openPicker()"
                    @change="deliveryDate.date = $event.detail.value"
                    :value="deliveryDate.date"
                    readonly
                />
                <span class="inputErrorMsg">
                    {{ trans('pages.edit_deliverydate_page.date_error') }}
                </span>
            </div>
            <div class="field">
                <ui5-label for="driver">
                    {{ trans('pages.edit_deliverydate_page.driver') }}
                </ui5-label>
                <ui5-select
                    id="driver"
                    @change="
                        deliveryDate.driverId =
                            $event.detail.selectedOption.value
                    "
                >
                    <ui5-option value="-1">
                        {{ trans('pages.edit_deliverydate_page.filter') }}
                    </ui5-option>
                    <ui5-option
                        v-for="driver in drivers"
                        :key="driver.ID"
                        :selected="driver.ID == deliveryDate.driverId"
                        :value="driver.ID"
                    >
                        {{ driver.name }}
                    </ui5-option>
                </ui5-select>
            </div>
            <div class="field">
                <ui5-label for="truck">
                    {{ trans('pages.edit_deliverydate_page.truck') }}
                </ui5-label>
                <ui5-select
                    id="truck"
                    @change="
                        deliveryDate.truckId =
                            $event.detail.selectedOption.value
                    "
                >
                    <ui5-option value="-1">
                        {{ trans('pages.edit_deliverydate_page.filter') }}
                    </ui5-option>
                    <ui5-option
                        v-for="truck in trucks"
                        :key="truck.ID"
                        :selected="truck.ID == deliveryDate.truckId"
                        :value="truck.ID"
                    >
                        {{ truck.name }}
                    </ui5-option>
                </ui5-select>
            </div>
            <div
                class="field"
                v-if="deliveryDate"
            >
                <ui5-label for="deliverymethod">
                    {{ trans('pages.edit_deliverydate_page.delivery_method') }}
                </ui5-label>
                <ui5-select
                    id="deliverymethod"
                    @change="
                        deliveryDate.deliveryMethodId =
                            $event.detail.selectedOption.value
                    "
                >
                    <ui5-option value="-1">
                        {{ trans('pages.edit_deliverydate_page.filter') }}
                    </ui5-option>
                    <ui5-option
                        v-for="deliveryMethod in deliveryMethods"
                        :key="deliveryMethod.id"
                        :selected="
                            deliveryMethod.id == deliveryDate.deliveryMethodId
                        "
                        :value="deliveryMethod.id"
                    >
                        {{ deliveryMethod.name }}
                    </ui5-option>
                </ui5-select>
            </div>
            <div class="field">
                <ui5-label for="description">
                    {{ trans('pages.edit_deliverydate_page.region') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="description"
                    id="description"
                    @input="deliveryDate.description = $event.target.value"
                    :value="deliveryDate.description"
                />
            </div>
            <div class="field">
                <ui5-label for="full">
                    {{ trans('pages.edit_deliverydate_page.full') }}
                </ui5-label>
                <ui5-select
                    id="full"
                    @change="
                        deliveryDate.full = $event.detail.selectedOption.value
                    "
                >
                    <ui5-option
                        value="0"
                        :selected="0 == deliveryDate.full"
                    >
                        {{ trans('pages.edit_deliverydate_page.no') }}
                    </ui5-option>
                    <ui5-option
                        value="1"
                        :selected="1 == deliveryDate.full"
                    >
                        {{ trans('pages.edit_deliverydate_page.yes') }}
                    </ui5-option>
                </ui5-select>
            </div>
            <div class="field">
                <ui5-label for="fullDescription">
                    {{ trans('pages.edit_deliverydate_page.description') }}
                </ui5-label>
                <ui5-textarea
                    id="fullDescription"
                    name="fullDescription"
                    :value="deliveryDate.fullDescription"
                    @input="deliveryDate.fullDescription = $event.target.value"
                />
            </div>
            <div class="field">
                <ui5-label for="url">
                    {{ trans('pages.edit_deliverydate_page.google_url') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="url"
                    id="url"
                    :value="deliveryDate.url"
                    @input="deliveryDate.url = $event.target.value"
                />
            </div>
            <div>
                <h3>
                    {{ trans('pages.edit_deliverydate_page.linked_customers') }}
                </h3>
                <div class="selected-customers">
                    <div
                        v-for="(
                            customer, customerIndex
                        ) in deliveryDate.customers"
                        :key="customer.customerId"
                    >
                        <span class="customer-name">
                            {{ customer.customerId }} -
                            {{ customer.customerName }}
                        </span>
                        <span v-if="customer.routeId">
                            {{
                                trans('pages.edit_deliverydate_page.route', {
                                    name: routes.find(
                                        (x) => x.id == customer.routeId
                                    ).name,
                                })
                            }}
                        </span>
                        <i
                            class="fa fa-close fa-1x"
                            @click="
                                $delete(deliveryDate.customers, customerIndex)
                            "
                        />
                    </div>
                </div>

                <div class="customer-search">
                    <h2>
                        {{
                            trans(
                                'pages.edit_deliverydate_page.add_customers_search'
                            )
                        }}
                    </h2>
                    <ui5-input
                        type="Text"
                        name="name"
                        id="name"
                        :disabled="customerSearch.searching"
                        :value="customerSearch.name"
                        @input="
                            customerSearch.name = $event.target.value;
                            searchCustomerDebounced();
                        "
                        :placeholder="
                            trans('pages.edit_deliverydate_page.customer_name')
                        "
                    />
                    <ui5-input
                        type="Text"
                        name="customer_id"
                        id="customer_id"
                        :disabled="customerSearch.searching"
                        :value="customerSearch.ID"
                        @input="
                            customerSearch.ID = $event.target.value;
                            searchCustomerDebounced();
                        "
                        :placeholder="
                            trans(
                                'pages.edit_deliverydate_page.customer_number'
                            )
                        "
                    />
                    <spinner v-if="customerSearch.searching" />
                    <ul
                        class="results"
                        v-else
                    >
                        <template v-for="result in customerSearch.results">
                            <li
                                v-if="!customerExists(result.ID)"
                                :key="result.ID"
                                @click="
                                    addCustomer(result.ID, result.name, null)
                                "
                                class="link"
                            >
                                {{ result.ID }} - {{ result.name }}
                            </li>
                        </template>
                    </ul>
                </div>

                <div class="customer-rounds">
                    <h3>
                        {{
                            trans(
                                'pages.edit_deliverydate_page.add_customers_rounds'
                            )
                        }}
                    </h3>
                    <ui5-button
                        @click="showRoutes = true"
                        v-if="!showRoutes"
                    >
                        {{ trans('pages.edit_deliverydate_page.show_rounds') }}
                    </ui5-button>
                    <ul v-if="showRoutes">
                        <template v-for="route in routes">
                            <li
                                v-if="addingRoute"
                                :key="route.id"
                            >
                                {{ route.name }} (#{{ route.id }})
                            </li>
                            <li
                                v-else
                                :key="route.id"
                                class="link"
                                @click="addRoute(route)"
                            >
                                {{ route.name }} (#{{ route.id }})
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>

        <!-- Recurring Edit Scope Dialog -->
        <recurring-edit-scope-dialog ref="scopeDialog" />
    </div>
</template>
<script>
import deliveryDatesApi from '../api/deliveryDates';
import deliveryRoutesApi from '../api/deliveryRoutes';
import genericApi from '../api/generic';
import customerApi from '../api/customer';
import spinner from '../components/loader/Spinner';
import RecurringTripSettings from '../components/deliveryDates/RecurringTripSettings';
import RecurringEditScopeDialog from '../components/deliveryDates/RecurringEditScopeDialog';
import IsDebugMixin from '../mixins/is-debug';
import moment from 'moment';
import { showErrorMessage, showInfoMessage } from '../dialogs';
import _ from 'lodash';
import localization from '../mixins/localization';

export default {
    components: {
        spinner,
        RecurringTripSettings,
        RecurringEditScopeDialog
    },
    data() {
        return {
            deliveryDate: null,
            drivers: null,
            trucks: null,
            deliveryMethods: null,
            routes: [],
            customerSearch: {
                ID: '',
                name: '',
                results: [],
                searching: false,
            },
            showRoutes: false,
            addingRoute: false,
            // Recurring trip properties
            isRecurring: false,
            recurringConfig: {
                frequencyInterval: 1,
                daysOfWeek: [1], // Monday checked by default
                endType: 'never',
                endDate: '',
                startDate: moment().format('YYYY-MM-DD')
            }
        };
    },
    mixins: [IsDebugMixin, localization],
    computed: {
        searchCustomerDebounced() {
            return _.debounce(this.searchCustomer, 500);
        },
        isEditMode() {
            return !!this.$route.params.id;
        }
    },
    methods: {
        moment,
        addRoute(route) {
            this.addingRoute = true;
            customerApi
                .listCustomersForRoute(route.id)
                .then((response) => {
                    if (!response.data.data.length) {
                        return showErrorMessage(
                            this.trans(
                                'pages.edit_deliverydate_page.route_no_customers'
                            )
                        );
                    }
                    response.data.data.forEach((customer) => {
                        this.addCustomer(
                            customer.customerId,
                            customer.customerName,
                            route.id
                        );
                    });
                })
                .finally(() => {
                    this.addingRoute = false;
                });
        },
        addCustomer(customerId, customerName, routeId) {
            if (!this.customerExists(customerId)) {
                this.deliveryDate.customers.push({
                    customerId,
                    customerName,
                    routeId,
                });
            }
        },
        customerExists(customerId) {
            return (
                this.deliveryDate.customers.findIndex(
                    (x) => x.customerId == customerId
                ) > -1
            );
        },
        searchCustomer() {
            this.customerSearch.searching = true;
            genericApi
                .listGeneric(
                    'customer JOIN contacts on contacts.ID = customer.ID',
                    'name',
                    'name',
                    'customer.ID',
                    this.customerSearch.name,
                    this.customerSearch.ID,
                    'updated = 1'
                )
                .then((response) => {
                    this.customerSearch.results = response.data.data;
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans(
                            'pages.edit_deliverydate_page.customer_search_error'
                        )
                    );
                })
                .finally(() => {
                    this.customerSearch.searching = false;
                });
        },
        load() {
            deliveryDatesApi.listDrivers().then((response) => {
                this.drivers = response.data.data;
                if (!this.$route.params.id) {
                    const deliveryDate = this.deliveryDate
                        ? { ...this.deliveryDate }
                        : {};
                    deliveryDate.driverId = this.drivers[0]
                        ? this.drivers[0].ID
                        : null;
                    this.deliveryDate = deliveryDate;
                }
            });

            deliveryDatesApi.listTrucks().then((response) => {
                this.trucks = response.data.data;
                if (!this.$route.params.id) {
                    const deliveryDate = this.deliveryDate
                        ? { ...this.deliveryDate }
                        : {};
                    deliveryDate.truckId = this.trucks[0]
                        ? this.trucks[0].ID
                        : null;
                    this.deliveryDate = deliveryDate;
                }
            });

            deliveryDatesApi.listDeliveryMethods().then((response) => {
                this.deliveryMethods = response.data.data;
                if (!this.$route.params.id) {
                    const deliveryDate = this.deliveryDate
                        ? { ...this.deliveryDate }
                        : {};
                    deliveryDate.deliveryMethodId = this.deliveryMethods[0]
                        ? this.deliveryMethods[0].id
                        : null;
                    this.deliveryDate = deliveryDate;
                }
            });

            deliveryRoutesApi.listRoutes().then((response) => {
                this.routes = response.data.data;
            });

            if (this.$route.params.id) {
                deliveryDatesApi
                    .date(this.$route.params.id)
                    .then((response) => {
                        this.$store.commit(
                            'deliveryDates/setOffsetClicked',
                            this.$route.params.id,
                            { root: true }
                        );
                        const deliveryDate = response.data.data;
                        const customers = [...deliveryDate.customers];
                        deliveryDate.customers = [];
                        this.deliveryDate = deliveryDate;
                        customers.forEach((customer) => {
                            this.addCustomer(
                                customer.customerId,
                                customer.customerName,
                                null
                            );
                        });
                        this.$store.commit(
                            'general/setPageTitle',
                            this.trans(
                                'pages.edit_deliverydate_page.edit_trip',
                                { key: deliveryDate.key }
                            ),
                            { root: true }
                        );
                    });
            } else {
                const deliveryDate = this.deliveryDate
                    ? { ...this.deliveryDate }
                    : {};
                deliveryDate.toBePlanned = 0;
                deliveryDate.date = moment().format('YYYY-MM-DD');
                deliveryDate.description = '';
                deliveryDate.full = 0;
                deliveryDate.fullDescription = '';
                deliveryDate.url = '';
                deliveryDate.customers = [];
                this.deliveryDate = deliveryDate;
            }

            if (this.$route.query.customerForDeliveryDate) {
                const queryCustomer = JSON.parse(
                    this.$route.query.customerForDeliveryDate
                );
                this.addCustomer(
                    queryCustomer.customerNumber,
                    queryCustomer.customerName,
                    null
                );
            }
        },
        async editDeliveryDate() {
            if (this.isRecurring && !this.isEditMode) {
                // Create recurring trip
                this.createRecurringTrip();
            } else if (this.isEditMode && this.deliveryDate.recurringConfigId) {
                // Editing a recurring trip instance - ask for scope
                const scope = await this.$refs.scopeDialog.open();
                if (scope) {
                    this.updateRecurringTrip(scope);
                }
            } else {
                // Create or update regular trip
                this.createOrUpdateSingleTrip();
            }
        },

        async createRecurringTrip() {
            // Validate days selected
            if (this.recurringConfig.daysOfWeek.length === 0) {
                showErrorMessage(this.trans('pages.recurring.select_at_least_one_day'));

                return;
            }

            // Update start date to match trip date
            this.recurringConfig.startDate = this.deliveryDate.date;

            // Properly handle 0 as a valid value for deliveryMethod (Af Fabriek has ID=0)
            // Using ?? instead of || to preserve 0 as valid value
            const payload = {
                // Trip properties
                toBePlanned: this.deliveryDate.toBePlanned || 0,
                driver: this.deliveryDate.driverId || '',
                truck: this.deliveryDate.truckId || '',
                deliveryMethod: this.deliveryDate.deliveryMethodId ?? '',
                description: this.deliveryDate.description || '',
                full: this.deliveryDate.full || '',
                fullDescription: this.deliveryDate.fullDescription || '',
                url: this.deliveryDate.url || '',
                customers: this.deliveryDate.customers.map(x => x.customerId),

                // Recurring properties
                frequencyInterval: this.recurringConfig.frequencyInterval,
                daysOfWeek: this.recurringConfig.daysOfWeek.join(','),
                startDate: this.recurringConfig.startDate,
                endType: this.recurringConfig.endType,
                endDate: this.recurringConfig.endDate
            };

            try {
                const response = await deliveryDatesApi.createRecurringTrip(payload);
                showInfoMessage(
                    this.trans('pages.edit_deliverydate_page.recurring_created', {
                        count: response.data.data.generated_trip_count
                    })
                );
                this.$router.push('/deliverydates');
            } catch (error) {
                showErrorMessage(this.trans('pages.edit_deliverydate_page.save_error'));
                console.error('Error creating recurring trip:', error);
            }
        },

        async updateRecurringTrip(scope) {
            const dateId = this.$route.params.id;

            const updates = {
                toBePlanned: this.deliveryDate.toBePlanned || 0,
                date: this.deliveryDate.date,
                driver: this.deliveryDate.driverId || '',
                truck: this.deliveryDate.truckId || '',
                deliveryMethod: this.deliveryDate.deliveryMethodId ?? '',
                description: this.deliveryDate.description || '',
                full: this.deliveryDate.full || '',
                fullDescription: this.deliveryDate.fullDescription || '',
                url: this.deliveryDate.url || '',
                customers: this.deliveryDate.customers.map(x => x.customerId)
            };

            try {
                await deliveryDatesApi.updateRecurringInstance(dateId, scope, updates);

                const message = scope === 'this'
                    ? this.trans('pages.recurring.updated_this')
                    : this.trans('pages.recurring.updated_this_and_following');

                showInfoMessage(message);
                this.$router.push('/deliverydates');
            } catch (error) {
                showErrorMessage(this.trans('pages.edit_deliverydate_page.save_error'));
                console.error('Error updating recurring trip:', error);
            }
        },

        createOrUpdateSingleTrip() {
            const dateId = this.$route.params.id;
            const method = dateId ? 'update' : 'add';

            const payload = {
                toBePlanned: this.deliveryDate.toBePlanned || 0,
                date: this.deliveryDate.date,
                driver: this.deliveryDate.driverId || '',
                truck: this.deliveryDate.truckId || '',
                deliveryMethod: this.deliveryDate.deliveryMethodId ?? '',
                description: this.deliveryDate.description || '',
                full: this.deliveryDate.full || '',
                fullDescription: this.deliveryDate.fullDescription || '',
                url: this.deliveryDate.url || '',
                customers: this.deliveryDate.customers.map(x => x.customerId),
                deliverydate: dateId || undefined,
            };

            deliveryDatesApi[method](payload)
                .then((response) => {
                    if (!dateId) {
                        this.$store.commit(
                            'deliveryDates/setLastClicked',
                            response.data.data,
                            { root: true }
                        );
                    }
                    if (this.$route.query.customerForDeliveryDate) {
                        this.$router.go(-1); //Return to page with popup
                    } else {
                        this.$router.push('/deliverydates');
                    }
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.edit_deliverydate_page.save_error')
                    );
                });
        },
    },
    mounted() {
        this.load();
    },
};
</script>
